import { h } from "dreamland/core";
import htm from "htm/mini";

export const html = htm.bind(h);
